export const TEMPORARY_ACCESS_TEXT = {
  createNotice:
    'Se generará un acceso temporal. El usuario deberá definir su contraseña al ingresar a la aplicación.',
  generating: 'Generando…',
  generate: 'Generar contraseña temporal',
  regenerate: 'Generar nueva contraseña',
  generationError: 'No se pudo generar el acceso temporal.',
  close: 'Cerrar',
  user: 'Usuario:',
  password: 'Contraseña temporal:',
  show: 'Mostrar',
  hide: 'Ocultar',
  copy: 'Copiar',
  copied: 'Contraseña copiada',
  copyError: 'No se pudo copiar la contraseña. Puedes mostrarla y copiarla manualmente.',
  maskedPassword: '••••••',
  expiresIn: 'Expira en:',
  validity: '30 minutos',
  createdTitle: 'Acceso temporal creado',
  resetAlertTitle: 'Contraseña restablecida'
}

const RESET_CONFIRM = {
  title: 'Restablecer acceso',
  subtitle:
    'Se generará una contraseña temporal para que el usuario pueda recuperar el acceso a Ubiqua App.',
  submitLabel: TEMPORARY_ACCESS_TEXT.generate,
  paragraphs: [
    {
      text: 'La contraseña temporal se enviará a ',
      emphasis: 'email',
      suffix: '. También podrás copiarla y compartirla directamente con el usuario si es necesario.'
    },
    {
      text: 'La contraseña tendrá una validez de ',
      emphasis: 'validity',
      suffix:
        '. Al ingresar a la app, el usuario deberá seguir las instrucciones para definir una nueva contraseña.'
    }
  ]
}

const RESET_REPLACE = {
  title: 'Ya existe una contraseña temporal',
  submitLabel: TEMPORARY_ACCESS_TEXT.regenerate,
  paragraphs: [
    {
      text: 'Este usuario ya tiene una contraseña temporal que expira en ',
      emphasis: 'remaining',
      suffix: '.'
    },
    {
      text: 'Si generas una nueva, la contraseña actual dejará de ser válida y se enviará otra al correo del usuario.'
    },
    { text: '¿Deseas generar una nueva contraseña temporal?' }
  ]
}

const RESET_EXPIRED = {
  title: 'La contraseña temporal ha expirado.',
  submitLabel: TEMPORARY_ACCESS_TEXT.regenerate,
  paragraphs: [
    { text: 'Genera una nueva contraseña temporal para que el usuario pueda recuperar el acceso.' }
  ]
}

export function getResetDialogContent(kind) {
  switch (kind) {
    case 'replace':
      return RESET_REPLACE
    case 'expired':
      return RESET_EXPIRED
    default:
      return RESET_CONFIRM
  }
}

const ACCESS_CREATE = {
  variant: 'create',
  modalTitle: 'Usuario creado',
  alertTitle: 'Usuario creado',
  message: 'El usuario se creó correctamente.',
  paragraphs: [
    {
      text: 'Entregue este acceso al usuario después de verificar su identidad. La aplicación le pedirá definir su propia contraseña.'
    }
  ],
  footer: 'Solo se muestra en esta operación. Si la pierde, deberá generar otro acceso temporal.'
}

const ACCESS_RESET = {
  variant: 'reset',
  modalTitle: 'Contraseña temporal generada',
  alertTitle: TEMPORARY_ACCESS_TEXT.resetAlertTitle,
  message: 'La contraseña temporal se envió al correo del usuario.',
  paragraphs: [
    {
      text: 'La contraseña temporal se ha generado y enviado al correo del usuario. Si necesitas compartirla directamente, puedes copiarla y enviársela después de verificar su identidad.'
    },
    {
      text: 'El usuario deberá ingresar a Ubiqua App con esta contraseña temporal y seguir las instrucciones para definir una nueva.'
    }
  ]
}

const ACCESS_REPLACEMENT = {
  variant: 'reset-replacement',
  modalTitle: 'Nueva contraseña temporal generada',
  alertTitle: TEMPORARY_ACCESS_TEXT.resetAlertTitle,
  message: 'La nueva contraseña temporal se envió al correo del usuario.',
  paragraphs: [
    {
      text: 'La nueva contraseña temporal se ha generado y enviado al correo del usuario. La contraseña anterior ya no es válida.'
    },
    {
      text: 'Comparte esta contraseña con el usuario para que pueda ingresar a Ubiqua App y definir una nueva contraseña.'
    }
  ]
}

export function getTemporaryAccessContent(action) {
  switch (action) {
    case 'reset':
      return ACCESS_RESET
    case 'reset-replacement':
      return ACCESS_REPLACEMENT
    default:
      return ACCESS_CREATE
  }
}
